import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';
import SvgIcon from './SvgIcon.vue';
import CloseIcon from '../icons/CloseIcon.vue';
import { addSuffix } from '../../../utils/utils';

type DoneFn = () => void;
type BeforeCloseFn = (done: DoneFn) => void;

interface Props {
  title?: string;
  value: boolean;
  modal?: boolean;
  size?: string | number;
  beforeClose?: BeforeCloseFn | undefined;
  appendToBody?: boolean;
  appendToRoomContainer?: false;
  closeOnClickModal?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Drawer',
  props: {
    title: { default: '' },
    value: { type: Boolean, default: false },
    modal: { type: Boolean, default: false },
    size: { default: '400' },
    beforeClose: { type: [Function, null], default: undefined },
    appendToBody: { type: Boolean, default: false },
    appendToRoomContainer: { type: Boolean, default: false },
    closeOnClickModal: { type: Boolean, default: true }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, value: boolean, modal: boolean, size: string | number, beforeClose: BeforeCloseFn | undefined, appendToBody: boolean, appendToRoomContainer: false, closeOnClickModal: boolean };





const drawerRef = ref();
const visible = ref(false);
const drawerContainerStyle = computed(() => `width: ${addSuffix(props.size)}`);

watch(
  () => props.value,
  val => {
    visible.value = val;
  }
);

watch(visible, val => {
  if (val) {
    if (props.appendToBody) {
      document.body.appendChild(drawerRef.value);
    } else if (props.appendToRoomContainer) {
      document.getElementById('roomContainer')?.appendChild(drawerRef.value);
    }
  }
});

function doClose() {
  visible.value = false;
  emit('input', false);
}

function handleClose() {
  if (props.beforeClose) {
    props.beforeClose(doClose);
  } else {
    doClose();
  }
}

let mouseDownInCurrentTarget = false;
let mouseUpInCurrentTarget = false;

function handleOverlayMouseUp(event: any) {
  mouseUpInCurrentTarget = event.target === event.currentTarget;
}

function handleOverlayMouseDown(event: any) {
  mouseDownInCurrentTarget = event.target === event.currentTarget;
}

function handleOverlayClick() {
  if (!props.closeOnClickModal) {
    return;
  }
  if (mouseDownInCurrentTarget && mouseUpInCurrentTarget) {
    handleClose();
    mouseDownInCurrentTarget = false;
    mouseUpInCurrentTarget = false;
  }
}

return { __sfc: true,props, emit, drawerRef, visible, drawerContainerStyle, doClose, handleClose, mouseDownInCurrentTarget, mouseUpInCurrentTarget, handleOverlayMouseUp, handleOverlayMouseDown, handleOverlayClick, SvgIcon, CloseIcon }
}

})